@if(hasActiveCampaign) {
  @if(!loading) {
  <ng-container>
    <div class="invite-card" [ngClass]="{'invite-card-expand' : expandWidth}">
      <div class="invite-content">
        <!--<p><strong>{{discount.Title}}</strong></p>
        <p class="invite-text" [innerHTML]="discount.Comment"></p>-->
        <p style="margin-top: 20px;"><strong>{{ title }}</strong></p>
        <button mat-raised-button class="invite-button" (click)="recieveClickOfferAction('InviteFriends')">{{ 'Intellitrailer.Rental.Screen.btnInvite' | translate : 'Invite' }}</button>
      </div>
    </div>
  </ng-container>
    }
    @else if (loading) {
  <ng-container>
    <div style="margin:auto; width: 100px; height: 100px;">
      <mat-progress-spinner diameter="50" mode="indeterminate" style="margin:auto"></mat-progress-spinner>
      <div style="text-align: center; width: 100px; margin-top: 25px">
        {{ 'Intellitrailer.Rental.Screen.LoadingReturn' | translate : 'Loading...' }}
      </div>
    </div>
  </ng-container>
    }
}
